module.exports = "table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\nth, td {\r\n  padding: 15px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n.order-drop-img {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  border: 2px solid #ffffff;\r\n  margin-right: 7px;\r\n  -o-object-fit: cover;\r\n     object-fit: cover;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-detail/customer-detail.component.css
// module id = ./src/app/customer-detail/customer-detail.component.css
// module chunks = main